<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center p-4">
    <div class="absolute inset-0 bg-black/50 backdrop-blur-sm" @click="$emit('close')"></div>
    <div class="relative bg-white rounded-2xl shadow-2xl border border-orange-200/20 max-w-md w-full max-h-[90vh] overflow-hidden">
      <!-- Modal Header -->
      <div class="flex items-center justify-between p-6 border-b border-orange-200/50">
        <div class="flex items-center">
          <div class="w-10 h-10 mr-3">
            <img 
              src="/logo6.png" 
              alt="Annzz Logo" 
              class="w-full h-full object-contain"
            />
          </div>
          <div>
            <h3 class="text-xl font-bold text-gray-900 font-luxury">Contact Us</h3>
            <p class="text-sm text-gray-600 font-light">Get in touch with ANNZZ</p>
          </div>
        </div>
        <button 
          @click="$emit('close')"
          class="w-8 h-8 bg-gray-100 hover:bg-gray-200 rounded-full flex items-center justify-center transition-colors duration-200"
        >
          <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Contact Information -->
      <div class="p-6 space-y-6">
        <!-- Phone Numbers -->
        <div class="space-y-4">
          <h4 class="text-lg font-semibold text-gray-900 flex items-center">
            <svg class="w-5 h-5 mr-2 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Phone Numbers
          </h4>
          <div class="space-y-2">
            <div class="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
              <span class="font-medium text-gray-700">SAJIL</span>
              <a href="tel:+918281887403" class="text-orange-600 hover:text-orange-800 font-semibold">
                +91 828 188 7403
              </a>
            </div>
            <div class="flex items-center justify-between p-3 bg-orange-50 rounded-lg">
              <span class="font-medium text-gray-700">WINSON</span>
              <a href="tel:+919745222188" class="text-orange-600 hover:text-orange-800 font-semibold">
                +91 974 522 2188
              </a>
            </div>
          </div>
        </div>

        <!-- Email -->
        <div class="space-y-2">
          <h4 class="text-lg font-semibold text-gray-900 flex items-center">
            <svg class="w-5 h-5 mr-2 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Email
          </h4>
          <div class="p-3 bg-orange-50 rounded-lg">
            <a href="mailto:annzzgold@gmail.com" class="text-orange-600 hover:text-orange-800 font-semibold">
              annzzgold@gmail.com
            </a>
          </div>
        </div>

        <!-- Address -->
        <div class="space-y-2">
          <h4 class="text-lg font-semibold text-gray-900 flex items-center">
            <svg class="w-5 h-5 mr-2 text-orange-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            Address
          </h4>
          <div class="p-3 bg-orange-50 rounded-lg">
            <p class="text-gray-700 leading-relaxed">
              10/581, 582, 2nd Floor,<br>
              Pavana Building, Pallikkulam Road,<br>
              Thrissur, Kerala - 680 001
            </p>
          </div>
        </div>

        <!-- Action Buttons -->
        <div class="flex space-x-3 pt-4">
          <button
            @click="callSajil"
            class="flex-1 bg-orange-600 text-white px-4 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors duration-200 flex items-center justify-center"
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Call SAJIL
          </button>
          <button
            @click="callWinson"
            class="flex-1 bg-orange-600 text-white px-4 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-colors duration-200 flex items-center justify-center"
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Call WINSON
          </button>
        </div>

        <div class="pt-2">
          <button
            @click="sendEmail"
            class="w-full bg-gray-100 text-gray-700 px-4 py-3 rounded-lg font-semibold hover:bg-gray-200 transition-colors duration-200 flex items-center justify-center"
          >
            <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Send Email
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContactUsModal',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close'],
  methods: {
    callSajil() {
      window.open('tel:+918281887403', '_self')
    },
    callWinson() {
      window.open('tel:+919745222188', '_self')
    },
    sendEmail() {
      window.open('mailto:annzzgold@gmail.com', '_self')
    }
  }
}
</script>

<style scoped>
.font-luxury {
  font-family: 'Playfair Display', serif;
}
</style>
